<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 id="tituloPainel" class="card-dados__titulo mb-0">Listagem</h3>

        <div v-if="value.length > 1" class="text-xs-right acao-expandir-recolher">
            <v-btn id="botaoExpandirTodos" v-if="ultimoEstadoPaineis === 'recolhido'" flat @click="expandirTodos" class="botao-simples mr-3">
                <v-icon left size="15">fas fa-chevron-down</v-icon>
                Expandir Todos
            </v-btn>
            <v-btn id="botaoRecolherTodos" v-else flat @click="recolherTodos" class="botao-simples mr-3">
                <v-icon left size="15">fas fa-chevron-up</v-icon>
                Recolher Todos
            </v-btn>
        </div>

        <v-expansion-panel v-model="paineis" expand class="painel-itens" :class="{ 'mt-3': value.length < 2}">
            <v-expansion-panel-content v-for="lote in value" :key="lote.id" class="painel-itens__linha cabecalho-painel">
                <template v-slot:header>
                    <p>
                        <strong>{{ lote.descricao }}</strong> -
                        <v-tooltip top v-if="lote.motivo">
                            <a slot="activator">
                                {{ lote.situacao | azEnum(situacoesItensELotes) }}
                                <i class="fas fa-comment" aria-hidden="true"/>
                            </a>
                            {{ lote.motivo }}
                        </v-tooltip>
                        <span v-else>
                            {{ lote.situacao | azEnum(situacoesItensELotes) }}
                        </span>
                    </p>
                    <div class="painel-itens__info">
                        <p class="mr-2">Exclusivo {{formatarLista(portes) | azConcat}}:</p>
                        <div class="az-checkbox">
                            <v-radio-group id="checkboxExclusividade" row
                                           @click.native.stop="$emit('alteracaoExclusividadeLote', {id: lote.id, novoValor: lote.porteExclusivo} )"
                                           v-model="lote.porteExclusivo">
                                <v-radio label="Sim" :value="true" color="primary"></v-radio>
                                <v-radio label="Não" :value="false" color="primary"></v-radio>
                            </v-radio-group>
                        </div>
                        <v-btn id="botaoRemover" @click.native.stop="$emit('excluirLote', lote.id, 'lote')" flat
                               class="botao-simples">
                            <v-icon left size="15">fas fa-trash-alt</v-icon>
                            Remover
                        </v-btn>
                    </div>
                </template>

                <painel-lote-tabela
                    :itens="lote.itens"
                    :possuiValorReferencia="possuiValorReferencia"
                    :casasDecimais="casasDecimais"
                    :casasDecimaisQuantidade="casasDecimaisQuantidade"
                    :prefixOuSuffixValor="prefixoValor"
                    :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                    :criterioJulgamento="criterioJulgamento"/>

                <div class="total total-mobile" v-if="possuiValorReferencia && isCriterioJulgamentoMaiorDesconto">
                    <p>
                        <strong>Desconto:</strong> {{ lote.totalGeral | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                    </p>
                </div>
                <div class="total total-mobile" v-if="possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto">
                    <p>
                        <strong>Total Unitário:</strong> {{ lote.totalUnitario | cdCurrency(prefix, casasDecimais)}}{{suffix}} &nbsp;|&nbsp;
                        <strong>Total Geral:</strong> {{ lote.totalGeral | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                    </p>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <div class="total total-listagem" v-if="possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto && value.length > 1">
            <p>
                <strong>Total: </strong> {{ total | cdCurrency(prefix, casasDecimais)}}{{suffix}}
            </p>
        </div>
    </v-flex>
</template>

<script>
import PainelLoteTabela from './PainelLoteTabela'
import {situacoesItensELotes} from '@/core/constants'

export default {
    name: 'PainelLoteEdicao',
    components: {
        PainelLoteTabela
    },
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        criterioJulgamento:{
            type: String
        },
        prefixoValor:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        possuiValorReferencia:{
            type: Boolean,
            default: null
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            ultimoEstadoPaineis: 'recolhido',
            totalmenteRecolhido: true,
            paineis: [],
            totalmenteExpandido: false,
            situacoesItensELotes
        }
    },
    computed: {
        total() {
            let total = 0
            this.value.forEach(lote => {
                if (lote.totalGeral > 0) {
                    total += lote.totalGeral
                }
            })
            return total
        },
        prefix(){
            return this.prefixoValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixoValor === '%' ? '%' : ''
        }
    },
    mounted() {
        this.expandirTodos()
    },
    methods: {
        expandirTodos() {
            const todosPaineisAbertos = this.value.map(() => {
                return true
            })
            this.paineis = todosPaineisAbertos
            this.totalmenteExpandido = true
        },
        recolherTodos() {
            const todosPaineisFechados = this.value.map(() => {
                return false
            })
            this.paineis = todosPaineisFechados
            this.totalmenteExpandido = false
            this.verificarUltimoEstado()
        },
        verificarUltimoEstado() {
            if (this.totalmenteExpandido) {
                this.ultimoEstadoPaineis = 'expandido'
            } else if (this.totalmenteRecolhido) {
                this.ultimoEstadoPaineis = 'recolhido'
            }
        }
    },
    watch: {
        paineis() {
            let todosRecolhidos = true
            let todosExpandidos = true

            for (let posicao of this.paineis) {
                if (!posicao) {
                    todosExpandidos = false
                } else {
                    todosRecolhidos = false
                }
            }

            this.totalmenteExpandido = todosExpandidos
            this.totalmenteRecolhido = todosRecolhidos
            this.verificarUltimoEstado()
        }
    }
}
</script>

<style lang="stylus">
    .botao-simples
        text-transform none !important
        color rgba(0, 0, 0, .54) !important

        .v-icon
            margin-right 10px

    .painel-itens
        box-shadow none
        margin 0 16px
        width auto
        border-width 1px 0 0 0
        border-color #ebebeb
        border-style solid
        font-weight 500

        p
            margin-bottom 0

        &__linha
            border 1px solid #ebebeb
            margin-bottom 20px

            .v-expansion-panel__header
                padding 5px 16px
                color #777

            .v-tooltip a
                color #777

            .v-tooltip a i
                font-size 10px

        &__info
            display flex
            align-items center
            justify-content flex-end

        &__combo
            width 110px
            margin-left 10px

            .v-select
                padding-top 0

        .az-checkbox
            height 25px !important

    .total
        margin 0 20px 16px
        text-align right
        color #777
        font-size 13px

        p
            margin-bottom 0

    @media (max-width 720px)
        .painel-itens
            margin 0

            &__linha
                border 0

        .total
            text-align left
</style>
